import api from "../api/axios";
import { User } from "../Types/User/UserModel";
import { ViewUser } from "../Types/User/ViewUserModel";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export const USER_QUERY_KEY = ["users"];
export const USER_DETAIL_QUERY_KEY = "userDetails";
export const USER_VIEW_QUERY_KEY = ["view-user-master"];

export interface RegisterPayload {
  username: string;
  emp_no: string;
  password: string;
  password_confirmation: string;
}
export interface PasswordResetPayload {
  password: string;
  password_confirmation: string;
}

export interface BlockPayload {
  reason: string;
}

export const ViewuserService = {
  getAllUserView: async () => {
    const response = await api.get(`api/view-user-master`);
    return response.data;
  },

  getUserViewById: async (userId: number) => {
    const response = await api.get(`api/view-user-master/${userId}`);
    return response.data;
  },
};

export const userService = {
  getAllUser: async () => {
    const response = await api.get("api/auth/users");
    return response.data;
  },
  registerUser: async (payload: RegisterPayload) => {
    const response = await api.post("api/auth/register", payload);
    return response.data;
  },
  getUserDetailsByEmpNo: async (emp_no: string): Promise<User | null> => {
    const allUsers: User[] = await userService.getAllUser();
    const user = allUsers.find((u) => u.emp_no === emp_no);
    return user || null;
  },
  unlockUser: async (userId: number) => {
    const response = await api.post(`api/auth/unlock-user/${userId}`);
    return response.data;
  },
  resetPassword: async (userId: number, payload: PasswordResetPayload) => {
    const response = await api.post(
      `api/auth/reset-password/${userId}`,
      payload,
    );
    return response.data;
  },
  unblockUser: async (userId: number) => {
    const response = await api.post(`api/auth/unblock-user/${userId}`);
    return response.data;
  },

  blockUser: async (userId: number, payload: { reason: string }) => {
    const response = await api.put(`api/auth/block-user/${userId}`, payload);
    return response.data;
  },
};
